import { ClienteXCiudad } from "../../login/cliente_login";

export class MovimientosConsulta {
    constructor(
        public cliente?: ClienteXCiudad, 
        public segmento?: number) { }
}

export class Movimiento
    {
        constructor(
        public MovimientosPendientes?: MovimientosEntity[],
        public MovimientosFacturados?: MovimientosEntity[],
        public MovimientosPendientesInspeccion?: MovimientosEntity[]
        ){}
    }

export class MovimientosEntity
    {
        constructor(
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public CodigoAseguradora?: number,
        public CodigoRolEmpleado?: number,
        public CodigoUnidad?: number,
        public NumeroMovimiento?: number,
        public Poliza?: string,
        public Ramo?: string,
        public TipoMovimiento?: string,
        public Estado?: string,
        public FechaSolicitud?: string,
        public FechaFacturacion?: string,
        ){}
    }
    export class MovimientosDescripEntity
    {
        constructor(
        public detalles?: string
        ){}
    }
    export class ArchivosMoivimientos {
        constructor(
            public CodigoArchivo?: number,
            public NombreArchivo?: string,
            public NombreAdjunto?: string
        ) {
    
        }
    
    }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/movimientos_entity.ts